export const environment = {
    firebase: {
        apiKey: 'AIzaSyBKZdc3SXhSDhJJrBNQT5JKg0t8PGg-Ri0',
        authDomain: 'anima-55837.firebaseapp.com',
        projectId: 'anima-55837',
        storageBucket: 'anima-55837.appspot.com',
        messagingSenderId: '272596405227',
        appId: '1:272596405227:web:40bbbf2c3f7b2a232fe7ae',
        measurementId: 'G-L210LG3QXW'
    },
    appVersion: require('../../../../package.json').version,
    paypalId: 'AZOlmXhW1-5fC4A1BMatBuJJxcpkNvWF_V68L98v3tQGcwtjMtj9jOxlhtP5DktauEZ6WI2HG2P6QQUl',
    // paypalId: 'ASgtjFrQt3uCwx7eTod02SLeizJkwgApotCQymMoS2PYMA0l-io-2NDtOBBUnxlkgiI1dQIwOrX9BFQq',
    production: true,
    isProd: true,
    isLocal: false,
    googleClientId: '1082322181123-7rmg57kpndgiutfmetl6alaaljkbv9tu.apps.googleusercontent.com',
    googleTagId: 'GTM-TGQ3FF3',
    facebookClientId: '1',
    defaultLanguage: 'en',
    availableLanguages: ['en', 'uk'],
    apiUrl: '/api',
    liqPay: 'https://liqpay.anima.ua/api',
    // paypal: 'https://pay-sandbox.anima.help',
    paypal: 'https://pay.anima.help',
    notify: 'https://notify.anima.help',
    aiUrl: 'https://chat-bot-4b5tzreqna-ew.a.run.app',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
